/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import type { FC } from 'react';

type FlairProps = {
  src: string;
  alt: string;
  href?: string;
};

const Flair: FC<FlairProps> = ({ href, src, alt }) => {
  const image = (
    <img
      css={css`
        margin: 0 0.1em;
        max-width: 1em;
        user-select: none;
        pointer-events: none;
      `}
      src={src}
      alt={alt}
    />
  );

  return href ? (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {image}
    </a>
  ) : (
    image
  );
};

export default Flair;
